import { environment } from '../../environments/environment';

export enum Parceiro {
    DEFAULT = 0,
    BNB = environment.parceiros.BNB.id,
    BRASILCAP = environment.parceiros.BRASILCAP.id,
    CAPFIADOR = environment.parceiros.CAPFIADOR.id,
    O2 = environment.parceiros.O2.id
};

type Logo = {
    default: string;
    primary: string;
    primaryContrast: string;
};

export const parceiroLogo: { [key in Parceiro]: Logo } = {
    [Parceiro.DEFAULT]: {
        default: 'assets/images/brasilcap_logo.svg',
        primary: 'assets/images/brasilcap_logo.svg',
        primaryContrast: 'assets/images/brasilcap_logo.svg'
    },
    [Parceiro.BNB]: {
        default: 'assets/images/logo-bnb_fundo_branco.svg',
        primary: 'assets/images/logo-bnb_fundo_branco.svg',
        primaryContrast: 'assets/images/logo_bnb_fundo_vermelho_pequeno.png'
    },
    [Parceiro.BRASILCAP]: {
        default: 'assets/images/brasilcap_logo.svg',
        primary: 'assets/images/brasilcap_logo.svg',
        primaryContrast: 'assets/images/brasilcap_logo.svg'
    },
    [Parceiro.CAPFIADOR]: {
        default: 'assets/images/brasilcap_logo.svg',
        primary: 'assets/images/brasilcap_logo.svg',
        primaryContrast: 'assets/images/brasilcap_logo.svg'
    },
    [Parceiro.O2]: {
        default: 'assets/images/brasilcap_logo.svg',
        primary: 'assets/images/brasilcap_logo.svg',
        primaryContrast: 'assets/images/brasilcap_logo.svg'
    }
};

export const parceiroPath: { [key in Parceiro]: string } = {
    [Parceiro.DEFAULT]: '/',
    [Parceiro.BNB]: '/bnb',
    [Parceiro.BRASILCAP]: '/brasilcap',
    [Parceiro.CAPFIADOR]: '/capfiador',
    [Parceiro.O2]: '/o2'
};

export const parceiroTheme: { [key in Parceiro]: string } = {
    [Parceiro.DEFAULT]: 'brasilcap',
    [Parceiro.BNB]: 'bnb',
    [Parceiro.BRASILCAP]: 'brasilcap',
    [Parceiro.CAPFIADOR]: 'brasilcap',
    [Parceiro.O2]: '/o2'

};

export class ParceiroProvider {
    static #parceiro: Parceiro = Parceiro.DEFAULT;

    static get() {
        return this.#parceiro;
    }

    static getSistema(parceiro: any) {
        return Object.values(environment.parceiros).find(x => {
            if (typeof parceiro === 'string')
                return x.title === parceiro.toUpperCase();
            else
                return x.id === parceiro;

        });
    }

    static set(value: Parceiro) {
        this.#parceiro = value;
    }
}
